<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="d-flex flex-row justify-content-between">
        <div>
          <h2 class="page-title">User Management - Gudang</h2>
        </div>
        <div class="d-flex flex-row justify-content-end">
          <div class="mr-3">
            <button
              class="btn"
              type="button"
              style="
                background-color: #f36f21;
                color: white;
                width: 100%;
                font-weight: bold;
                margin: 0;
                font-family: proxima-nova, sans-serif;
              "
              @click="openCreateUserModal"
            >
              Create Gudang
            </button>
          </div>
          <a href="" class="btn" style="    margin-right: -1rem !important;
    padding: 0;">
            <img src="@/assets/img/notification.svg" alt="" style="display: none;">
          </a>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <div class="bg-white shadow box-content mt-5">
      <h5
        style="
          font-size: 20px;
          color: #4d4d4d;
          font-weight: 600;
          font-family: proxima-nova, sans-serif;
        "
      >
        Gudang List
      </h5>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text bg-white">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <input
          class="form-control filterInput col-lg-2"
          type="search"
          placeholder="Search Gudang"
          aria-label="Search"
          v-model="filter.name"
          @click="vue_universal_table.update++"
          style="
            display: inline-block;
            width: auto;
            margin-right: 10px;
            font-family: proxima-nova, sans-serif;
            border-left: 0;
          "
        />
      </div>

      <vue-universal-table
        api_url="/api/gudang/list"
        :filter="filter"
        :buttons="vue_universal_table.buttons"
        :fields="vue_universal_table.fields"
        :update="vue_universal_table.update"
        :indexing="true"
        :table_striped="false"
        :pagination="false"
        sort_order="DESC"
        sort_by="id"
        @onEdit="editGudang"
        @onDelete="deleteGudang"
      ></vue-universal-table>
    </div>

    <cu-gudang
      v-if="modal.new || modal.edit"
      :data="modal.edit ? modal.editData : null"
      api_new="/api/gudang/add"
      :api_edit="modal.edit ? `/api/gudang/update/${modal.editData.id}` : null"
      form_type="Gudang"
      :is_company_exist="false"
      @refreshData="vue_universal_table.update++"
      @closeModal="
        modal.new = false;
        modal.edit = false;
      "
    ></cu-gudang>
  </div>
</template>

<script>
import CuGudang from "./children/CUGudang";

export default {
  metaInfo: {
    title: "List Gudang",
  },
  data() {
    return {
      modal: {
        new: false,
        edit: false,
        editData: false,
      },

      filter: {
        search: "",
      },
      vue_universal_table: {
        buttons: [
          {
            title: "Edit",
            variable: null,
            class: "fas fa-edit  btn-secondary rounded-button float-right",
            condition: `data.flag === 2`
          },
          {
            title: "Delete",
            variable: "id",
            class: "fas fa-trash  btn-secondary rounded-button",
            condition: `data.flag === 2`
          },
        ],
        fields: [
          { title: "Region Gudang", variable: "region", disable_sort: true },
          { title: "Kode Gudang", variable: "loc_code", disable_sort: true },
          { title: "Nama Gudang", variable: "name", disable_sort: true }
        ],
        update: 0,
      },
      plants: [],
    };
  },
  components: {
    CuGudang,
  },
  mounted() {},
  methods: {
    openCreateUserModal() {
      this.modal.new = true;
    },
    editGudang(gudang) {
      // Parse the user data (if needed)
      const gudangData = JSON.parse(gudang);
      const gudangId = gudangData.id; // Ensure 'id' is correctly extracted

      // Set the modal state to edit mode
      this.modal.editData = gudangData;
      this.modal.edit = true;

      // Now, construct the API URL with the correct 'userId'
      this.vue_universal_table.api_edit = `/api/gudang/update/${gudangId}`;
    },
    deleteGudang(gudangId) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to recover this entry!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085D6",
          cancelButtonColor: "#D33",
          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .delete("/api/gudang/delete/" + gudangId)
              .then(() => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `Gudang has been successfully deleted`,
                });
                this.vue_universal_table.update++;
              })
              .catch((err) => {
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: err.response.data.message,
                });
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.box-content {
  padding: 20px;
  border-radius: 10px;
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

/* tms-table start */
.tms-table {
  width: 100%;
  border-collapse: collapse;
}

.tms-table th,
.tms-table td {
  padding: 8px;
  text-align: left;
  vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
  color: #bcbcbc;
  font-weight: normal;
  border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
  font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
  border-top: none;
}
/* tms-table end */
</style>
